var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"all_DC_info_small",style:({
    height: '100%',
    width: '100%',
    backgroundImage: 'url(' + this.backgroud_png + ') ',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    opacity: 0.8,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }